import classNames from "classnames";
import { ExportIcon } from "components/atoms/Icon";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { Paragraph } from "components/atoms/Typography";
import { DataSource, Table } from "components/molecules/Table";
import SearchBar from "components/organisms/SearchBar/SearchBar";
import CsvDownloadButton from "react-json-to-csv";
import { TABLE_IDS } from "utils/constants";
import styles from "../../../components/organisms/Tables/table.module.scss";
import { useCarbonPoliciesData } from "../CarbonPoliciesPage.hooks";
import policiesTableStyles from "./CarbonPoliciesTable.module.scss";

export type CarbonPoliciesTableData = CarbonPoliciesTableDatum & DataSource;

function CarbonPoliciesTable() {
    const {
        columns,
        dataSource: carbonPoliciesTableData,
        isLoading: isCarbonPoliciesLoading,
    } = useCarbonPoliciesData();

    if (isCarbonPoliciesLoading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <div
                className={classNames(styles.topContainer, styles.carbonPoliciesTopContainer)}
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <Paragraph
                    style={{
                        color: "var(--audette-gray-500)",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <span style={{ marginLeft: "4px" }}>{carbonPoliciesTableData.length} Carbon Policies</span>
                </Paragraph>
                <CsvDownloadButton
                    data={carbonPoliciesTableData}
                    filename="carbonPoliciesTableData.csv"
                    className="projects-report-export-button"
                    delimiter=","
                >
                    <div className={styles.exportButton}>
                        <ExportIcon />
                        <Paragraph>Export</Paragraph>
                    </div>
                </CsvDownloadButton>
                <div style={{ marginLeft: "none" }}>
                    <SearchBar tableId={TABLE_IDS.CARBON_POLICIES} />
                </div>
            </div>
            <div className={`${styles.report} ${policiesTableStyles.report}`}>
                <Table
                    columns={columns}
                    dataSource={carbonPoliciesTableData}
                    className={styles.reportTable}
                    defaultOrderBy={{ key: "name", order: "asc" }}
                    parentComponentWithSearchBarId={TABLE_IDS.CARBON_POLICIES}
                />
            </div>
        </>
    );
}

export default CarbonPoliciesTable;
